export const MAX_PREVIEW_SIDE = 4096;
export const MAX_CANVAS_SIDE = 8192;
